import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from '../../customComponents/SelectStatus';


export const initObject = {
  id: undefined,
  rowIndex: undefined,
  title: "",
  auditPeriodId: 0,
  auditPeriodTitle: "",
  auditPlaceId: 0,
  auditPlaceTitle: "",
  auditFormTypeId: 0,
  auditFormTypeTitle: "",
  questionId: 0,
  questionTitle: "",
  answerType: 1,

  buildingId: null,
  buildingTitle: "",
  floorId: null,
  floorTitle: "",
  roomId: null,
  roomTitle: "",
  seatId: null,
  seatTitle: "",

  answerOfQuestionId: null,
  answerOfQuestionTitle: "",
  editorId: null,
  editorFullName: "",
  creatorId: null,
  creatorFullName: "",
  createAt: "",
  editedAt: "",

  answerCount: "",
  enteredAnswer: "",
  status: "",
  categoryTitle: "همه"
};

export const rowFormatter = (row, idx) => {
  if (!row.rowIndex) return "table-warning";
  else return "";
  // return row.trafficTypeCode && row.trafficTypeCode > 0 ?  : '';
};

export const editRowFormatter = (row, idx) => {
  // if (row.status === null || row.status === "NotCompleted") return "holiday-row-class";
  // else return "edited-row-class";
  // // return row.trafficTypeCode && row.trafficTypeCode > 0 ?  : '';
  if (row.status !== null && row.status !== "NotCompleted") return "edited-row-class";
  return "";
};

export const placColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "title",
    text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری (بلوک-طبقه-اتاق)",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "buildingCount",
    text: "تعداد بلوک ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorCount",
    text: "تعداد طبقه",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "roomCount",
    text: "تعداد اتاق",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "seatCount",
    text: "تعداد تخت",
    sort: false,
    sortCaret: sortCaret,
  },
];

export const provienceColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "title",
    text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری (بلوک-طبقه-اتاق)",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "activeCount",
    text: "تعداد مرکز",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "buildingCount",
    text: "تعداد بلوک ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorCount",
    text: "تعداد طبقه",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "roomCount",
    text: "تعداد اتاق",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "seatCount",
    text: "تعداد تخت",
    sort: false,
    sortCaret: sortCaret,
  },
];

export const countryColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری (بلوک-طبقه-اتاق)",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "title",
    text: "تعداد مرکز",
    sort: false,
    sortCaret: sortCaret,
  },

  {
    dataField: "buildingCount",
    text: "تعداد بلوک ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorCount",
    text: "تعداد طبقه",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "roomCount",
    text: "تعداد اتاق",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "seatCount",
    text: "تعداد تخت",
    sort: false,
    sortCaret: sortCaret,
  },
];


export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "enteredAnswer",
        type: "text",
        component: Input,
        auditPlaceholder: "پاسخ",
        label: "پاسخ",
        rowIdx: 1,
        class: "col-lg-6"
      },
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const filterFields = [
  {
    name: "auditPeriodId",
    lable: "دوره ارزیابی",
    type: "component",
    list: [],
    rowIdx: 1,
    component: (props) => (
      <SelectObjectsField
        api="api/AuditPeriod"
        reduxState="auditPeriods"
        sname="auditPeriodId"
        label=" "
        {...props}
      />
    ),
    relField: [],
    relValues: {},
  },
  {
    name: "categoryId",
    lable: "کاربری (بلوک-طبقه-اتاق)",
    type: "component",
    list: [],
    rowIdx: 1,
    component: (props) => (
      <SelectObjectsField
        api="api/category"
        reduxState="roomCategories"
        sname="categoryId"
        label=" "
        useInFilter={true}
        {...props}
      />
    ),
    relField: [],
    relValues: {},
  },

];


export const filterInitialValues = {
  filter: {
    categoryId: 0,
    auditPeriodId: 0,
    // auditFormTypeId: 0,
    // auditPlaceId: 0,
    // questionId: 0,
    // answerOfQuestionId: 0,

  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 100,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 1000,
};


export const prepareFilter = (queryParams, values) => {
  const { categoryId, auditPeriodId } = values;
  // const { provinceId, auditPeriodId, auditFormTypeId, auditPlaceId, questionId, answerOfQuestionId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  if (categoryId !== undefined)
    filter.categoryId = categoryId !== "" ? +categoryId : 0;
  else
    filter.categoryId = 0

  if (auditPeriodId !== undefined)
    filter.auditPeriodId = auditPeriodId !== "" ? +auditPeriodId : 0;
  else
    filter.auditPeriodId = 0



  // filter.auditPlaceId = auditPlaceId !== "" ? +auditPlaceId : 0;
  // filter.auditFormTypeId = auditFormTypeId !== "" ? +auditFormTypeId : 0;
  // filter.questionId = questionId !== "" ? +questionId : 0;
  // filter.answerOfQuestionId = answerOfQuestionId !== "" ? +answerOfQuestionId : 0;
  newQueryParams.filter = filter

  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;

  if (filter.categoryId > 0 && idx === 0) {
    whereClause = `categoryId=@${idx}`
    whereClauseParameters.push(filter.categoryId)
    idx++;
  }
  else if (filter.categoryId > 0 && idx > 0) {
    whereClause = whereClause + ` and categoryId=@${idx}`
    whereClauseParameters.push(filter.categoryId)
    idx++;
  }



  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  // title: Yup.string()
  //   .required("پر کردن فیلد الزامی است"),
  // auditPeriodId: Yup.number()
  //   .required("auditPeriodId is required"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

